import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["outletSelect", "roleWrapper"]

  // Definisi Role Group (pastikan nama role sama persis dengan di DB)
  parettoRoles = ["store_manager", "barista", "ba", "kasir"]
  middleRoles = ["pj_store", "staff_middle"]

  connect() {
    this.filterRoles()
  }

  filterRoles() {
    const select = this.outletSelectTarget
    const selectedOption = select.options[select.selectedIndex]
    
    // Ambil data-type dari option yang dipilih
    const outletType = selectedOption.dataset.outletType?.toLowerCase()

    if (!outletType) return

    let allowedRoles = []

    if (['paretto', 'develop'].includes(outletType)) {
      allowedRoles = this.parettoRoles
    } else if (outletType === 'middle') {
      allowedRoles = this.middleRoles
    } else {
      this.showAllRoles()
      return
    }

    this.toggleRoles(allowedRoles)
  }

  toggleRoles(allowedRoles) {
    this.roleWrapperTargets.forEach(wrapper => {
      const roleName = wrapper.dataset.roleName
      
      // Ubah selector dari checkbox ke radio
      const radioButton = wrapper.querySelector("input[type='radio']")

      // Skip logic ini untuk admin (admin selalu tampil)
      if (roleName === 'admin') return 

      if (allowedRoles.includes(roleName)) {
        // Tampilkan Wrapper
        wrapper.style.display = "flex" // Gunakan flex agar rapi sesuai class view
      } else {
        // Sembunyikan Wrapper
        wrapper.style.display = "none"
        
        // Reset pilihan jika role yang sedang dipilih tiba-tiba disembunyikan
        if (radioButton && radioButton.checked) {
          radioButton.checked = false
        }
      }
    })
  }

  showAllRoles() {
    this.roleWrapperTargets.forEach(wrapper => {
      wrapper.style.display = "flex"
    })
  }
}